import { API_URL } from "../config/connect";

export async function getBanner() {
    const response = await fetch(`${API_URL}/api/v1/banner`);

    if (!response.ok) {
        throw new Error(`Failed to fetch banner: ${response.status}`);
    }

    return response.json();
}
